/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
import * as React from 'react';

function SvgSend(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={24}
      height={24}
      fill='none'
      viewBox='0 0 24 24'
      {...props}
    >
      <path
        fill='currentColor'
        fillRule='evenodd'
        d='M21.737 1.298L1.752 8.292a.75.75 0 00-.057 1.393l8.737 3.883 3.883 8.737a.75.75 0 001.393-.057l6.994-19.985a.75.75 0 00-.965-.965zm-9.842 11.868l8.311-8.312-5.289 15.113-3.022-6.8zm-1.061-1.06l8.312-8.312L4.033 9.083l6.8 3.022z'
      />
    </svg>
  );
}

export default SvgSend;
